module.exports = __webpack_public_path__ + "media/images/icon-success-1108a73dc6c7aeaabb8d6f14d62a292e.svg";